import { connect } from 'react-redux';
import CreateSpace from './CreateSpace';
import { create } from '../../../redux/actions/space';

const mapDispatchToProps = (dispatch) => ({
  createSpaces: (spaces) => dispatch(create(spaces)),
});

export default connect(undefined, mapDispatchToProps)(CreateSpace);
